import { BaseOddCrystalsDrawer } from './BaseOddCrystalsDrawer';
import { gameConfig } from '../../../core/configs';

export class OddCrystalsDesktopDrawer extends BaseOddCrystalsDrawer {
  constructor() {
    super();
    this.container = null;
    this.config = {
      size: 120,
      margin: 10,
    };
  }

  setContainerPosition() {
    this.setPosition(this.container, gameConfig.oddCrystalsPosition);
  }

  setOddCrystals() {
    const odds = super.getOddCrystals({ parentWidth: gameConfig.width });
    this.container.addChild(...odds);
  }

  async onLoad() {
    return this.loadResource();
  }

  async executeMainScene() {
    await this.loadResource();
    this.setContainerPosition();
    this.setOddCrystals();
    this.setOddCrystalObserver({
      activeConfig: [1.3, 1],
      disabledConfig: [1.1, .5],
    });
  }
}
